<template>
  <main class="page content">
    <section class="container">
      <extra-filter></extra-filter>
      <div :class="!loading ? '' : 'loading'">
        <extra v-if="extras && extras.length" v-for="(extra, index) in extras" :index="index" :extra="extra" :key="extra.slug"></extra>
        <div v-if="!extras || !extras.length">
          <h2>No Results</h2>
          <p>Please try again</p>
        </div>
        <v-waypoint @waypoint-in="nextPage" v-if="!loading"></v-waypoint>
      </div>
    </section>
    <button class="sttButton button is-primary" @click="scrollToTop" v-if="scrolled">Top</button>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ExtraFilter from '@/components/extras/ExtraFilter'
import Extra from '@/components/extras/Extra'

export default {
  name: 'extras',
  data () {
    return {
      page: 1,
      loading: true,
      topics: null,
      scrolled: false
    }
  },
  mounted () {
    if (!this.topic) {
      this.fetchExtras()
    }
  },
  methods: {
    nextPage () {
      if (this.page < this.totalExtraPages) {
        this.page++
      }
    },
    handleScroll (direction, going) {
      if (direction.y === 'down' && going === 'in') {
        this.scrolled = true
      } else if (direction.y === 'up' && going === 'out') {
        this.scrolled = false
      }
    },
    scrollToTop () {
      window.scrollTo(0, 0)
      this.scrolled = false
    },
    fetchExtras (scrollToTop = false, replace = true) {
      let vm = this
      let topicId = vm.thisTopic ? vm.thisTopic.id : ''
      vm.$axios.get('/extras', {
        params: {
          page: vm.page,
          year: vm.year,
          topic: topicId
        }
      })
      .then((response) => {
        vm.loading = false
        if (!replace) {
          vm.addToExtras(response.data.posts)
        } else {
          vm.setExtras(response.data)
        }
        if (scrollToTop) {
          vm.scrollToTop()
        }
      })
      .catch((err) => {
        vm.loading = false
        console.log(err.response)
      })
    },
    setPage (i, push = false) {
      let vm = this
      vm.page = parseInt(i)
    },
    ...mapActions([
      'setExtras',
      'addToExtras'
    ])
  },
  components: {
    ExtraFilter,
    Extra
  },
  computed: {
    topic () {
      return this.$route.query.topic
    },
    year () {
      return this.$route.query.year
    },
    thisTopic () {
      let vm = this
      if (vm.topics && vm.topic) {
        return vm.topics.find((topic) => {
          return topic.slug === vm.topic
        })
      }
    },
    ...mapGetters([
      'extras',
      'totalExtraPages'
    ])
  },
  watch: {
    year () {
      this.setPage(1)
      this.fetchExtras(true, true)
    },
    page () {
      this.fetchExtras(false, false)
    },
    thisTopic () {
      this.setPage(1)
      this.fetchExtras(true, true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import ../assets/styles/mixins

.page
  padding-bottom: 120px
  .container
    +desktop
      padding: 0
</style>



// WEBPACK FOOTER //
// Extras.vue?624912e0